import type { CohortRole, OrganizationRole } from 'types';

export type AdminUserListItem = {
  id: number;
  email: string;
  phone_number?: string | null;
  sms_opted_out_at?: string | null;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  is_active: boolean;
  is_superuser: boolean;
  has_completed_intake: boolean;
  organization_name: string | null;
  organization_role: OrganizationRole;
  created_at: string;
  updated_at: string;
};

export type AdminUserDetail = AdminUserListItem & {
  timezone: string;
  timezone_offset: number;
  organization_id: string | null;
  cohort_memberships: AdminUserCohortMembership[];
};

export type AdminUserCohortMembership = {
  id: string;
  cohort: {
    id: string;
    name: string;
    is_active: boolean;
    organization: {
      id: string;
      name: string;
    } | null;
  };
  role: CohortRole;
  mentor_id: number | null;
  is_current: boolean;
  created_at: string;
};

export type AdminUserCohortMembershipWriteResponse = {
  created: number;
  updated: number;
  already_present: Array<{
    cohort_id: string;
    membership_id: string;
  }>;
  skipped: Array<{
    cohort_id: string;
    reason: string;
  }>;
  memberships: AdminUserCohortMembership[];
};

export type UserFormData = {
  email: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  password: string;
  is_staff: boolean;
  is_superuser: boolean;
  has_completed_intake: boolean;
  timezone: string;
  organization_id: string | null;
  organization_role: OrganizationRole;
};


export type OrganizationOption = {
  id: string;
  name: string;
  org_id: string;
};

export type UserListFilters = {
  organization_id: string;
};

export const DEFAULT_USER_FORM: UserFormData = {
  email: '',
  phone_number: '',
  first_name: '',
  last_name: '',
  password: '',
  is_staff: false,
  is_superuser: false,
  has_completed_intake: false,
  timezone: 'UTC',
  organization_id: null,
  organization_role: 'user',
};
